export default __webpack_public_path__ + "static/media/square-exclamation.a9888a87.svg";